import { AiSearchRequest, AiSearchResponse } from "models/dto/searchApi";
import {
	AiSearchFeedbackRequest,
	AiSearchFeedbackResponse,
} from "models/dto/searchApi";
import { AiSearchApiClient } from "../apiClient/AiSearchApiClient";

export async function AiSearchQuery(
	client: AiSearchApiClient,
	request: AiSearchRequest
): Promise<AiSearchResponse> {
	return client.Post<AiSearchResponse>("/ask", request);
}

export function AiSearchFeedback(
	client: AiSearchApiClient,
	feedback: AiSearchFeedbackRequest
): Promise<AiSearchFeedbackResponse> {
	return client.Post<AiSearchFeedbackResponse>("/feedback", feedback);
}
